{
  "es": {
    "navbar": {
      "customer": {
        "after_care": "Posventa",
        "dashboard": "Inicio",
        "decisions": "Decisiones",
        "documents": "Documentos",
        "inspirations": "Inspiración",
        "installments": "Finanzas",
        "profile": "Tu perfil",
        "projectinfo": "Información",
        "question_lists": "FAQ",
        "surveys": "Encuestas",
        "ticket": {
          "new": "Nueva conversación"
        },
        "tickets": "Conversaciones",
        "units": "Libro del Edificio"
      },
      "employee": {
        "all_projects": "Proyectos",
        "client": "Perfil {client}",
        "contacts": "Contactos",
        "customer": "Cliente",
        "dashboard": "Inicio",
        "employee": "Empleado",
        "overview": "Vista general",
        "partner": "Colaborador",
        "profile": "Tu perfil",
        "project": {
          "after_care": "Posventa",
          "decisions": "Decisiones",
          "documents": "Documentos",
          "email_conversations": "Correos entrantes",
          "info": "Información",
          "installments": "Finanzas",
          "milestones": "Hitos",
          "news": "Novedades",
          "question_lists": "FAQ",
          "sales": "Ventas",
          "surveys": "Encuestas",
          "todos": "Tareas",
          "todos_v2": "Tareas v2"
        },
        "projects": "Proyectos",
        "ticket": {
          "new": "Nueva conversación"
        },
        "tickets": "Conversaciones"
      },
      "landmarks": {
        "employee": {
          "client": {
            "primary": "Navegación principal",
            "secondary": "Navegación secundaria"
          }
        }
      },
      "partner": {
        "contacts": "Contactos",
        "dashboard": "Inicio",
        "profile": "Tu perfil",
        "project": {
          "after_care": "Posventa",
          "decisions": "Decisiones",
          "documents": "Documentos",
          "tickets": "Conversaciones"
        },
        "projects": "Proyectos"
      },
      "topnavbar": {
        "company": "Organización",
        "helpcenter": "Centro de ayuda",
        "inviteManageMembers": "Invitar y gestionar miembros",
        "logout": "Cerrar sesión",
        "profile": "Perfil",
        "searchTeam": "Buscar organización",
        "selectTeam": "Seleccionar organización",
        "settings": "Ajustes",
        "team": "Equipo"
      }
    }
  }
}
